/* @ngInject */
function AssetPreviewApprovalButtonsController ($rootScope, $scope, $translate, $timeout, UdsModalService, ToastService, ArtsService, SegmentService, BannerService) {
  const getApprovalMessageModalController = () => import('../approval-message-modal/approval-message-modal.controller')
  const getRequestReviewApprovalModalController = () => import('../../../workflow/dialogs/request-review-approval/request-review-approval-dialog.controller')

  $scope.data = {
    flag: ''
  }
  $scope.showApprovalButtons = false

  $scope.statusType = {
    approved: 'APPROVED',
    rejected: 'REJECTED',
    adjust: 'PENDING_REWORK'
  }

  $scope.flags = {
    hide: false
  }

  const api = {
    _rejectArt,
    _approveArt,
    _requestAdjustments,
    _validateFunctionByFlag,
    _handleSuccess,
    _handleError,
    _getOriginState,
    _openApprovalWorkflowModal,
    _openApprovalMaterialModal
  }

  this.getApi = () => api

  activate()

  function activate () {
    if ($scope.internalApproval) {
      $scope.statusType.adjust = 'ADJUST'
    }
  }

  const deregisterApprovalButtonsHide = $rootScope.$on('asset-preview.approvalButtons.hide', () => {
    $scope.flags.hide = true
  })

  $scope.$on('$destroy', () => {
    deregisterApprovalButtonsHide()
  })

  $scope.openMessageModal = function (flag) {
    if ($scope.internalApproval) {
      api._openApprovalWorkflowModal(flag)
    }

    if ($scope.location === 'materialsApproval') {
      api._openApprovalMaterialModal(flag)
    }
  }

  $scope.toggleApprovalButtons = () => {
    $scope.showApprovalButtons = !$scope.showApprovalButtons
  }

  $scope.showRefreshStatus = () => {
    const isNotInternalApproval = !$scope.internalApproval
    const isNotPendingApprovalStatus = $scope.template.approvalStatus !== 'PENDING_APPROVAL' && $scope.template.approvalStatus !== 'DESIGNING'

    return isNotInternalApproval && isNotPendingApprovalStatus && $scope.showApprovalButtons === false
  }

  $scope.showApprovalButton = () => {
    const isInternalApproval = !!$scope.internalApproval
    const isPendingApprovalStatus = $scope.template.approvalStatus === 'PENDING_APPROVAL' || $scope.showApprovalButtons !== false

    return isInternalApproval || isPendingApprovalStatus
  }

  function _getOriginState (approvalStatus) {
    approvalStatus = typeof approvalStatus === 'string' ? approvalStatus.toUpperCase() : ''
    const enumApprovalStatus = {
      PENDING_APPROVAL: 'waiting_approved',
      PENDING_REWORK: 'waiting_adjust',
      REJECTED: 'rejected',
      APPROVED: 'approved'
    }

    return enumApprovalStatus[approvalStatus] || ''
  }

  function _validateFunctionByFlag (flag, message) {
    if (flag === 'REJECTED') {
      api._rejectArt($scope.template.id, flag, message)
    } else if (flag === 'PENDING_REWORK') {
      api._requestAdjustments($scope.template.id, flag, message)
    } else if (flag === 'APPROVED') {
      api._approveArt($scope.template.id, flag, message)
    }
  }

  function _rejectArt (artId, flag, message) {
    const originStage = api._getOriginState(flag)

    ArtsService.rejectArt(artId, { message })
      .then(() => {
        api._handleSuccess(flag, artId)
        SegmentService.track('approved-art', {
          art_id: artId,
          origin_stage: originStage,
          approved_status: 'rejected',
          approved: false,
          video: $scope.template.hasVideo
        })
      })
      .catch(() => { api._handleError(flag) })
  }

  function _requestAdjustments (artId, flag, message) {
    const originStage = api._getOriginState(flag)

    ArtsService.disapproveArt(artId, { message })
      .then(() => {
        api._handleSuccess(flag, artId)
        SegmentService.track('approved-art', {
          art_id: artId,
          origin_stage: originStage,
          approved_status: 'send_adjust',
          approved: false,
          video: $scope.template.hasVideo
        })
      })
      .catch(() => { api._handleError(flag) })
  }

  function _approveArt (artId, flag, message) {
    const originStage = api._getOriginState(flag)

    ArtsService.approveArt(artId, { message })
      .then(() => {
        api._handleSuccess(flag, artId)
        ArtsService.getPhotoframesCount(artId).then(photoframesCount => {
          SegmentService.track('approved-art', {
            art_id: artId,
            origin_stage: originStage,
            approved_status: 'approved',
            approved: true,
            photoframes: photoframesCount,
            video: $scope.template.hasVideo
          })
        })
      })
      .catch(() => { api._handleError(flag) })
  }

  function _handleSuccess (flag, assetId) {
    $rootScope.$emit('onDeleteAsset', { assetId, shouldClose: true })
    $rootScope.$emit('reload-approval-list')

    if (flag === 'REJECTED') {
      ToastService.showSuccessToast($translate.instant('approvalMessageModal.disapprove.success'))
    } else if (flag === 'PENDING_REWORK') {
      ToastService.showSuccessToast($translate.instant('approvalMessageModal.requestAdjustments.success'))
    } else if (flag === 'APPROVED') {
      ToastService.showSuccessToast($translate.instant('approvalMessageModal.approve.success'))
    }
  }

  function _handleError (flag) {
    if (flag === 'REJECTED') {
      ToastService.showErrorToast($translate.instant('approvalMessageModal.disapprove.error'))
    } else if (flag === 'PENDING_REWORK') {
      ToastService.showErrorToast($translate.instant('approvalMessageModal.requestAdjustments.error'))
    } else if (flag === 'APPROVED') {
      ToastService.showErrorToast($translate.instant('approvalMessageModal.approve.error'))
    }
  }

  function _openApprovalWorkflowModal (to) {
    const approvalId = $scope.internalApproval.id
    const from = $scope.internalApproval.status

    if ($scope.previewFlags.isRequestingChanges) {
      $timeout(() => {
        $scope.previewFlags.isRequestingChanges = false
        $scope.previewFlags.isAddingAnnotation = false
        ToastService.closeCurrentToast()
      }, 0, true)

      return
    }

    if (to === $scope.statusType.adjust) {
      $rootScope.$emit('asset-preview-dialog.open-annotation')
      $scope.previewFlags.isRequestingChanges = true
      ToastService.showInfoToast($translate.instant('adjustWithAnnotation'))
      return
    }

    getRequestReviewApprovalModalController().then(({ RequestReviewApprovalController }) => {
      const requestReviewApproval = UdsModalService.createModal({
        controller: RequestReviewApprovalController,
        modalName: 'requestReviewApprovalDialog',
        data: {
          isPreview: true,
          taskId: $scope.internalApproval.taskId,
          assetId: $scope.template.id,
          approvalId,
          from,
          to
        }
      })
      requestReviewApproval.open()
    })
  }

  function _openApprovalMaterialModal (flag) {
    if ($scope.template.approvalStatus === flag) { return }
    $scope.data = { flag }
    getApprovalMessageModalController().then(({ ApprovalMessageModalController }) => {
      const approvalMessageModal = UdsModalService.createModal({
        controller: ApprovalMessageModalController,
        modalName: 'approvalMessageModal',
        data: $scope.data,
        onClose: (returnData) => {
          if (returnData) {
            api._validateFunctionByFlag(returnData.flag, returnData.message)
          }
        }
      })
      approvalMessageModal.open()
    })
  }
}

export { AssetPreviewApprovalButtonsController }
